import {UIMSingletonPageView} from '../ui_html/singleton_page/UIMSingletonPageView.ts'
import {type UIMFullscreenPageView} from '../ui_page/UIMFullscreenPageView.ts'

export class UIMFullscreenPageController {
    private readonly renderedPageList: UIMFullscreenPageView[] = []
    private readonly pageStack: UIMFullscreenPageView[] = []

    openUrl(pageUrl: string) {
        const page = this.getPage(pageUrl)
        page.build()
        this.pageStack.push(page)
    }

    closePage() {
        const currentPage = this.pageStack.pop()
        currentPage?.removeFromDOM()

        if(this.pageStack.length == 0) return

        const previousPage = this.pageStack[this.pageStack.length - 1]
        previousPage.build()
    }

    closeAllPages() {
        this.pageStack.forEach((page) => page.removeFromDOM())
        this.pageStack.length = 0
    }

    private createPage(pageUrl: string) {
        const page = new UIMSingletonPageView(pageUrl, () => this.closePage())
        this.renderedPageList.push(page)
        return page
    }

    private getPage(pageUrl: string): UIMFullscreenPageView {
        const page = this.getIfPageIsPreRendered(pageUrl)
        if(page) return page

        return this.createPage(pageUrl)
    }

    private getIfPageIsPreRendered(pageUrl: string): UIMFullscreenPageView | undefined {
        return this.renderedPageList.find((page) => page.pageId == pageUrl)
    }
}
